module.exports = __webpack_public_path__ + "img/logo-icon-app.44304f8c.png";